import React, { useState } from 'react';

import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';

import MenuItem from '@material-ui/core/MenuItem';

import axios from 'axios';

import { ToastContainer, toast } from 'react-toastify';

import * as API from 'app/constants/ApiConstants';

import * as APP from 'app/constants/AppConstants';

import './login.css';



/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */

/* Added the following code for POW-950.Harsha using AI Agent. October 9, 2026. Code Start */

const US_STATES = [

	'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',

	'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',

	'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',

	'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',

	'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',

	'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',

	'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'

];

const CA_PROVINCES = [

	'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador',

	'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island',

	'Quebec', 'Saskatchewan', 'Yukon'

];



function SignupField({ label, required, children }) {

	return (

		<div className="signup-field">

			<span className="signup-field-label">

				{label}

				{required ? ' *' : ''}

			</span>

			{children}

		</div>

	);

}

/* Code end. Harsha using AI Agent. October 9, 2026 */



function PartnerSignupTab({ onBackToLogin, onSignupSuccess }) {

	const [isSubmitting, setIsSubmitting] = useState(false);

	const [form, setForm] = useState({

		companyName: '',

		contactFirstName: '',

		contactLastName: '',

		email: '',

		password: '',

		confirmPassword: '',

		country: 'USA',

		phone: '',

		city: '',

		state: ''

	});



	const handleChange = (field) => (event) => {

		const value = event.target.value;

		if (field === 'country') {

			setForm({ ...form, country: value, state: '' });

			return;

		}

		setForm({ ...form, [field]: value });

	};



	/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */

	const handleSubmit = (event) => {

		event.preventDefault();

		setIsSubmitting(true);

		delete axios.defaults.headers.common.Authorization;

		axios.post(API.PARTNER_SIGNUP_URL, form)

	/* Code end. Harsha using AI Agent. October 7, 2026 */

			.then(response => {

				if (response.status === APP.SUCCESS) {
					/* Added the following code for POW-950.Harsha using AI Agent. October 9, 2026. Code Start */
					if (onSignupSuccess) {
						onSignupSuccess();
					} else {
						toast('Registration submitted.', { position: toast.POSITION.TOP_CENTER, className: 'foo-bar' });
						onBackToLogin();
					}
					/* Code end. Harsha using AI Agent. October 9, 2026 */
				}

			})

			.catch(error => {

				const message = error.response && error.response.data && error.response.data.erroMessage

					? error.response.data.erroMessage

					: 'Signup failed';

				toast(message, { position: toast.POSITION.TOP_CENTER, className: 'foo-bar' });

			})

			.finally(() => {

				setIsSubmitting(false);

			});

	};



	const stateOptions = form.country === 'CANADA' ? CA_PROVINCES : US_STATES;

	const stateLabel = form.country === 'CANADA' ? 'Province' : 'State';



	return (

		<div className="candidate-signup-form w-full">

			<ToastContainer />

			<form onSubmit={handleSubmit} className="w-full">

				<SignupField label="Company Name" required>

					<TextField

						fullWidth

						placeholder="Enter company name"

						value={form.companyName}

						onChange={handleChange('companyName')}

						required

						variant="outlined"

					/>

				</SignupField>

				<div className="signup-row">

					<SignupField label="Contact First Name" required>

						<TextField

							fullWidth

							placeholder="Enter first name"

							value={form.contactFirstName}

							onChange={handleChange('contactFirstName')}

							required

							variant="outlined"

						/>

					</SignupField>

					<SignupField label="Contact Last Name" required>

						<TextField

							fullWidth

							placeholder="Enter last name"

							value={form.contactLastName}

							onChange={handleChange('contactLastName')}

							required

							variant="outlined"

						/>

					</SignupField>

				</div>

				<SignupField label="Partner Email" required>

					<TextField

						fullWidth

						placeholder="Enter partner email"

						type="email"

						value={form.email}

						onChange={handleChange('email')}

						required

						variant="outlined"

					/>

				</SignupField>

				<SignupField label="Password" required>

					<TextField

						fullWidth

						placeholder="Enter password"

						type="password"

						value={form.password}

						onChange={handleChange('password')}

						required

						variant="outlined"

					/>

				</SignupField>

				<SignupField label="Confirm Password" required>

					<TextField

						fullWidth

						placeholder="Confirm password"

						type="password"

						value={form.confirmPassword}

						onChange={handleChange('confirmPassword')}

						required

						variant="outlined"

					/>

				</SignupField>

				<SignupField label="Country" required>

					<TextField

						select

						fullWidth

						value={form.country}

						onChange={handleChange('country')}

						variant="outlined"

					>

						<MenuItem value="USA">USA</MenuItem>

						<MenuItem value="CANADA">Canada</MenuItem>

					</TextField>

				</SignupField>

				<SignupField label="Phone" required>

					<TextField

						fullWidth

						placeholder="Enter phone number"

						value={form.phone}

						onChange={handleChange('phone')}

						required

						variant="outlined"

					/>

				</SignupField>

				<SignupField label="Company City" required>

					<TextField

						fullWidth

						placeholder="Enter city"

						value={form.city}

						onChange={handleChange('city')}

						required

						variant="outlined"

					/>

				</SignupField>

				<SignupField label="State / Province" required>

					<TextField

						select

						fullWidth

						displayEmpty

						value={form.state}

						onChange={handleChange('state')}

						required

						variant="outlined"

						renderValue={(selected) => {

							if (!selected) {

								return <span style={{ color: '#9e9e9e' }}>{`Select ${stateLabel.toLowerCase()}`}</span>;

							}

							return selected;

						}}

					>

						{stateOptions.map((s) => (

							<MenuItem key={s} value={s}>{s}</MenuItem>

						))}

					</TextField>

				</SignupField>

				<Button

					type="submit"

					variant="contained"

					color="primary"

					className="w-full normal-case mt-16"

					disabled={isSubmitting}

				>

					{isSubmitting ? 'Creating account...' : 'Create partner account'}

				</Button>

			</form>

		</div>

	);

}



export default PartnerSignupTab;

/* Code end. Harsha using AI Agent. October 7, 2026 */

